import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    Avatar,
    LinearProgress,
    Chip,
    useTheme,
    Button,
} from "@mui/material";

import { getMyCourses } from "../api/courseAPI";
import { AuthContext } from "../theme/AuthContext";
import { useNavigate } from "react-router-dom";

export default function Courses() {
    const theme = useTheme();
    const auth = useContext(AuthContext);
    console.log("Auth Context:", auth.user.username);
    const navigate = useNavigate();

    const userId = auth.user ? auth.user.username : null;

    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userId) return;

        const fetchCourses = async () => {
            try {
                const data = await getMyCourses(userId);
                console.log("Fetched Courses:", data);
                setCourses(data);
            } catch (error) {
                console.error("Failed to load courses", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCourses();
    }, [userId]);

    return (
        <Box
            sx={{
                p: 3,
                backgroundColor: theme.palette.background.default,
                flexGrow: 1,
                width: "100%",
            }}
        >

            {/* ========= MY COURSE SECTION ========= */}
            <Box sx={{ mt: 4, backgroundColor: theme.palette.background.paper, padding: "20px" }}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography sx={{ fontWeight: 400, fontSize: 16, color: theme.palette.text.primary }}>
                        My course
                    </Typography>

                </Box>

                {/* Course List */}
                <Grid container spacing={3} gap={4}>
                    {courses.map((course, index) => (
                        <Grid size={12} key={course.courseId}
                        >
                            <Card
                            
                                onClick={() => navigate(`/course/${course.courseId}`, { state:  course  })}
                                sx={{
                                    p: 3.5,
                                    boxShadow: "none",
                                    cursor: "pointer", // 🖱 pointer cursor
                                    borderBottom:
                                        index === courses.length - 1
                                            ? "none"
                                            : `1px solid ${theme.palette.divider}`,
                                    display: { xs: "block", md: "flex" },
                                    gap: 2,
                                    alignItems: "center",

                                    //  Hover effect
                                    transition: "background-color 0.25s ease",
                                    "&:hover": {
                                        backgroundColor: theme.palette.action.hover,
                                    },
                                }}
                            >

                                {/* Course Image */}
                                <Box
                                    sx={{
                                        width: 260,
                                        height: 143,
                                        borderRadius: 2,
                                        overflow: "hidden",
                                        flexShrink: 0,
                                    }}
                                >
                                    <img
                                        src={course.imageUrl?.videoUrl || ""}
                                        alt={course.title}
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                </Box>

                                {/* Details */}
                                <Box sx={{ flexGrow: 1 }}>

                                    {/* Top Row */}
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Chip
                                            label={course.category}
                                            size="small"
                                            sx={{
                                                background: theme.palette.action.selected,
                                                borderRadius: 2,
                                            }}
                                        />

                                        {Number(course.progress) > 80 && (
                                            <Button
                                                variant="contained"
                                                size="small"
                                                sx={{ textTransform: "none" }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/final-assessment/${course.courseId}`);
                                                }}
                                            >
                                                🎓 Final Assessment
                                            </Button>
                                        )}
                                    </Box>

                                    <Typography sx={{ fontSize: 18, fontWeight: 500, mt: 1 }}>
                                        {course.title}
                                    </Typography>

                                    <Typography sx={{ fontSize: 13, color: theme.palette.text.secondary }}>
                                        {course.organisation}
                                    </Typography>

                                    <Typography sx={{ fontSize: 13, mt: 1 }}>
                                        Complete – {course.progress}%
                                    </Typography>

                                    <LinearProgress
                                        variant="determinate"
                                        value={course.progress}
                                        sx={{
                                            height: 6,
                                            borderRadius: 5,
                                            mt: 0.5,
                                        }}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

            </Box>
        </Box>
    );
}
